import { Link } from "@tanstack/react-router";
import { Github, Twitter } from "lucide-react";
import logoPng from "@/logo.png";

export function PublicFooter() {
	return (
		<footer className="surface-glass surface-divider w-full border-t">
			<div className="mx-auto max-w-6xl px-4 py-6">
				<div className="flex flex-col items-center gap-4 text-sm text-muted-foreground md:grid md:grid-cols-3 md:items-center">
					{/* Logo */}
					<div className="flex flex-col items-center gap-2 md:items-start md:justify-self-start">
						<Link to="/" className="flex items-center gap-2">
							<img src={logoPng} alt="m8tes.ai" className="h-10 w-auto shrink-0 dark:invert" />
						</Link>
					</div>

					{/* Navigation links */}
					<nav className="flex flex-wrap items-center justify-center gap-2 md:justify-self-center">
						<Link to="/signup" className="hover:text-foreground transition-colors">
							Get started
						</Link>
						<span className="text-muted-foreground">•</span>
						<Link to="/login" className="hover:text-foreground transition-colors">
							Log in
						</Link>
						<span className="text-muted-foreground">•</span>
						<Link to="/pricing" className="hover:text-foreground transition-colors">
							Pricing
						</Link>
						<span className="text-muted-foreground">•</span>
						<Link to="/privacy-policy" className="hover:text-foreground transition-colors">
							Privacy
						</Link>
						<span className="text-muted-foreground">•</span>
						<Link to="/terms" className="hover:text-foreground transition-colors">
							Terms
						</Link>
					</nav>

					{/* Tagline, Copyright & Social */}
					<div className="flex flex-col items-center gap-2 md:items-end md:justify-self-end">
						<p>Automate your work.</p>

						<div className="flex items-center gap-3">
							<p>© {new Date().getFullYear()} m8tes</p>

							{/* Social icons */}
							<a
								href="https://github.com/m8tes-ai"
								target="_blank"
								rel="noopener noreferrer"
								className="hover:text-foreground transition-colors"
								aria-label="GitHub"
							>
								<Github className="size-5" />
							</a>
							<a
								href="https://twitter.com/m8tes_ai"
								target="_blank"
								rel="noopener noreferrer"
								className="hover:text-foreground transition-colors"
								aria-label="X (Twitter)"
							>
								<Twitter className="size-5" />
							</a>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}
